import React from 'react';
import { Reveal } from './Reveal';
export function AboutSection() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-24" data-id="element-18" data-mp="2lc6pcterus05">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-19" data-mp="2lcybldmhbddr">
        <span className="text-3xl leading-none" aria-hidden="true" data-id="element-20" data-mp="2gcanp0tjrcnr">
          🎨
        </span>
        <h2 className="mt-6 text-[10px] font-semibold uppercase tracking-[0.24em] text-brand-terra sm:text-[11px]" data-id="element-21" data-mp="2bein7ieu6i7y">
          Sobre Arte Lista
        </h2>
        <p className="mt-6 font-display text-lg leading-relaxed text-brand-navy sm:text-2xl sm:leading-[1.5]" data-id="element-22" data-mp="27ei7zvjwy2zu">
          Nacimos con una misión clara: devolverle el tiempo y la paz mental a
          los docentes de Arte en Argentina. Sabemos lo que es preparar clases a
          las 11 de la noche sin saber qué actividad dar mañana.{' '}
          <span className="italic text-brand-terra" data-id="element-23" data-mp="1noy32w6y5ex3">
            Arte Lista es el sistema que nos hubiera gustado tener cuando
            empezamos.
          </span>
        </p>
      </Reveal>
    </section>;
}